var rules = function (blockClass) { return [
    "." + blockClass + " { background: #ccc }",
    'noscript { display: none !important; }',
]; };

export default rules;
